
import { Button, Card, Tooltip } from '@sede-enterprise/shell-ds-react-framework';
import { InfoCircle } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { mmOrMiles } from '../../../util/helperFunctions';
const TO_MILES = 39.3700787402;


const CRDetailCard = ({ label, tooltipContent, value, units, idPrefix }) => (
    <Card className="cr-details-card" bodyPadding={false} id={`${idPrefix}-card`}>
        <div className="cr-details-info" id={`${idPrefix}-info`}>
            <div className="label-container" id={`${idPrefix}-label-container`}>
                <p className="data-label" id={`${idPrefix}-label`}>{label}</p>
                <Tooltip
                    id={`${idPrefix}-tooltip`}
                    placement="bottom"
                    className="tooltip"
                    overlay={<div id={`${idPrefix}-tooltip-content`} className="tooltip-content">{tooltipContent}</div>}
                    trigger={
                        <Button
                            id={`${idPrefix}-button`}
                            size="xsmall"
                            variant="transparent"
                            iconOnly
                            icon={<InfoCircle id={`${idPrefix}-icon`} />}
                        />
                    }
                />
            </div>
            <p className="data-value" id={`${idPrefix}-value`}>
                {units ? (TO_MILES * value)?.toFixed(3) : value?.toFixed(3)} {mmOrMiles(units)}
            </p>
        </div>
    </Card>
);

export default CRDetailCard